var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { BLOG_TAGS } from "../components/BlogNavigation";
import { createContext, useContext, useState } from "react";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
import API_service from "@iscr/xAppLib/providers/API_service";
import { PAGE_IDS } from "@iscr/contentful/constants";
import { normalizeKeys } from "@iscr/contentful/functions";
const BlogContext = createContext(undefined);
export const useBlogContext = () => {
    const ctx = useContext(BlogContext);
    if (!ctx)
        throw new Error("useBlogContext must be used within BlogProvider");
    return ctx;
};
export const BlogProvider = ({ children }) => {
    const initialTag = BLOG_TAGS[0];
    const [selectedTag, setSelectedTagState] = useState(initialTag);
    const { data: availableTags } = useAsync(() => __awaiter(void 0, void 0, void 0, function* () {
        const checks = BLOG_TAGS.filter(tag => tag !== "All").map((tag) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield API_service.load_data("cms/getEntries", {
                content_type: PAGE_IDS.BLOG_POST,
                content_tags: [normalizeKeys(tag)],
                pagination: { limit: 1, skip: 0 },
                preview: false,
            });
            return response.status === "ok" && response.entries.total > 0 ? tag : null;
        }));
        const results = yield Promise.all(checks);
        return ["All", ...results.filter((tag) => Boolean(tag))];
    }), []);
    // Keep context and URL in sync
    const setSelectedTag = (tag) => {
        setSelectedTagState(tag);
        //  navigate({ pathname: safePath, search: params.toString() }, { replace: true });
    };
    return (_jsx(BlogContext.Provider, { value: { selectedTag, setSelectedTag, availableTags }, children: children }));
};
